import { IRootState } from '../../../store'
import { ICcHpiInjuryDetailsState } from '../store/ccHpi.types'

export const getCcHpiInjuryDetailsSelector = (state: IRootState): ICcHpiInjuryDetailsState => state.ccHpiInjuryDetails
